import React, { memo, useCallback, useState } from 'react';
import cx from 'classnames';

import { Loading, Button } from '@carbon/react';

import './_override.scss';

import styles from './element_item.module.scss';

import {
  ChangeCatalog,
  RotateClockwise,
  RotateCounterclockwise,
} from '@carbon/react/icons';

const ElementViewer = memo(
  ({ item, rotate = 0, showEditing = false, onEdit = () => {} }) => {
    let element;
    let editing;

    const [isLoaded, setIsLoaded] = useState(false);
    const handleIsLoaded = useCallback(() => {
      setIsLoaded(true);
    }, [setIsLoaded]);

    //onsole.info('rotation:', rotate);

    if (item.file) {
      if (item.file.type === 'video/mp4') {
        element = (
          <video
            className="element-editing--main-img"
            src={item.blob}
            controls
            autoPlay
            muted
            onLoad={handleIsLoaded}
            onCanPlay={handleIsLoaded}
            style={isLoaded === false ? { display: 'none' } : {}}></video>
        );
      } else {
        element = (
          <img
            className={`element-editing--main-img ${
              rotate > 0 ? `rotate${rotate}` : ''
            }`}
            src={item.blob}
            alt=""
            style={isLoaded === false ? { display: 'none' } : {}}
            onLoad={handleIsLoaded}
          />
        );
      }
    } else {
      if (item.type === 1) {
        element = (
          <video
            className="element-editing--main-img"
            src={item.s3_url}
            controls
            autoPlay
            muted
            onLoad={handleIsLoaded}
            onCanPlay={handleIsLoaded}
            style={isLoaded === false ? { display: 'none' } : {}}></video>
        );
      } else {
        element = (
          <img
            className={`element-editing--main-img ${
              rotate > 0 ? `rotate${rotate}` : ''
            }`}
            src={item.s3_url}
            alt=""
            style={isLoaded === false ? { display: 'none' } : {}}
            onLoad={handleIsLoaded}
          />
        );
      }
    }

    if (showEditing === true) {
      editing = (
        <div className={cx(styles.buttonGroup)}>
          { item.type !== 1 && (
            <Button
              renderIcon={(props) => <RotateCounterclockwise size={20} {...props}/>}
              hasIconOnly
              kind="primary"
              iconDescription="Bild nach Links drehen"
              tooltipPosition="left"
              tooltipAlignment="center"
              onClick={() => onEdit(-90, false)}
            />
          )}
          { item.type !== 1 && (
            <Button
              renderIcon={(props) => <RotateClockwise size={20} {...props}/>}
              hasIconOnly
              kind="primary"
              iconDescription="Bild nach Rechts drehen"
              tooltipPosition="left"
              tooltipAlignment="center"
              onClick={() => onEdit(90, false)}
            />
          )}
          <Button
            renderIcon={(props) => <ChangeCatalog size={20} {...props}/>}
            hasIconOnly
            kind="primary"
            iconDescription="Datei / Element austauschen"
            tooltipPosition="left"
            tooltipAlignment="center"
            onClick={() => onEdit(0, true)}
          />
        </div>
      );
    }

    return (
      <div className="element-editing--main-img-container rotation-wrapper-inner">
        {element}
        {editing}
        {isLoaded === false && (
          <Loading active={isLoaded} withOverlay={false} className="element-editing-img-loading"/>
        )}
      </div>
    );
  }
);

export default ElementViewer;
